export const BROKER = {
  name: "Darryl Kelly",
  title: "Licensed Life Insurance Broker",
  email: "darrylkelly@policyprovisions.com",
  phone: "(470) 870-9388",
  phoneRaw: "+14708709388",
  npn: "18367935",
  calendarUrl: "https://calendar.app.google/5TsFu4t7GDKK6Na4A",
  photo: "/darryl-kelly.png",
};

export const BRAND = {
  name: "Policy Provisions",
  tagline: "Protect what matters most.",
};

export const INSURANCE_TYPES = [
  {
    id: "term",
    name: "Term Life",
    short: "Affordable coverage for a chosen period.",
    long:
      "Term life insurance provides a death benefit for a specific number of years, typically 10, 20, or 30. It's the most affordable way to get substantial coverage during the years your family depends on your income.",
    highlights: ["Lowest cost per dollar of coverage", "Flexible 10–30 year terms", "Convertible to permanent"],
    bestFor: "Income replacement during peak earning years",
  },
  {
    id: "whole",
    name: "Whole Life",
    short: "Lifelong protection that builds cash value.",
    long:
      "Whole life insurance offers permanent coverage with level premiums and a guaranteed cash value component that grows tax-deferred over time.",
    highlights: ["Lifetime coverage", "Fixed premiums", "Guaranteed cash value growth"],
    bestFor: "Estate planning and lifelong protection",
  },
  {
    id: "iul",
    name: "Index Universal Life (IUL)",
    short: "Flexible premiums with market-linked growth.",
    long:
      "IUL policies provide permanent life insurance with a cash value component tied to a market index (like the S&P 500), offering upside potential with downside protection.",
    highlights: ["Flexible premiums", "Tax-advantaged growth", "Market-linked, downside protected"],
    bestFor: "Long-term wealth accumulation with protection",
  },
  {
    id: "final_expense",
    name: "Final Expense",
    short: "Cover end-of-life costs with ease.",
    long:
      "Smaller whole life policies designed to cover funeral expenses, medical bills, and remaining debts so your loved ones aren't burdened.",
    highlights: ["Simplified underwriting", "Coverage $5K–$50K", "Guaranteed acceptance options"],
    bestFor: "Seniors planning final arrangements",
  },
  {
    id: "return_of_premium",
    name: "Return of Premium",
    short: "Outlive your policy? Get your money back.",
    long:
      "Return of Premium term life policies refund 100% of the premiums you've paid if you outlive the term, combining protection with a savings element.",
    highlights: ["100% premium refund if you outlive term", "Fixed level premiums", "20 or 30 year terms"],
    bestFor: "Those who want coverage with a guaranteed payback",
  },
];

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY","DC"
];
